import {AxiosResponse} from 'axios';
import {USER_DATA} from 'commons/constants';
import {CreateAccountValues, EfeResponse, LoginValues, RecoveryTokenResponse} from 'commons/models';
import {EfeUser, KeycloakTokenResponse} from 'commons/types/Types';
import EfeApi from 'services/api/Api';

import {REACT_APP_KEYCLOAK_CLIENT_ID} from 'commons/env/env-vars';

function getHeaders(values: EfeUser): any {
    let headers: any = {};
    if (values.token) {
        headers = {
            Authorization: `${values.tokenType} ${values.token}`,
            'content-type': 'application/x-www-form-urlencoded',
        };
    } else {
        headers = {
            'content-type': 'application/x-www-form-urlencoded',
        };
    }
    return headers;
}

async function getToken(values: LoginValues): Promise<EfeResponse<KeycloakTokenResponse>> {
    try {
        const params = new URLSearchParams();
        params.append('username', values.username);
        params.append('password', values.password);
        params.append('client_id', `${REACT_APP_KEYCLOAK_CLIENT_ID}`);
        params.append('grant_type', 'password');
        return await EfeApi.Keycloak.post<KeycloakTokenResponse>('/token', params, {
            headers: getHeaders(USER_DATA),
        }).then((response) => {
            return Promise.resolve({
                data: response.data,
                status: 'Success',
                success: true,
                code: response.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function refreshToken(values: EfeUser): Promise<EfeResponse<KeycloakTokenResponse>> {
    try {
        const params = new URLSearchParams();
        params.append('client_id', `${REACT_APP_KEYCLOAK_CLIENT_ID}`);
        params.append('grant_type', 'refresh_token');
        params.append('refresh_token', values.refreshToken);
        return await EfeApi.Keycloak.post<KeycloakTokenResponse>('/token', params, {
            headers: getHeaders(values),
        }).then((response) => {
            return Promise.resolve({
                data: response.data,
                status: 'Success',
                success: true,
                code: response.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function logout(values: EfeUser): Promise<EfeResponse<number>> {
    try {
        const params = new URLSearchParams();
        params.append('refresh_token', values.refreshToken);
        params.append('username', values.username);
        return await EfeApi.Users.post<number>('/api/v1/users/logout', params, {
            headers: getHeaders(values),
        }).then((response) => {
            return Promise.resolve({
                data: response.status,
                status: 'Success',
                success: true,
                code: response.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function createAccount(
    values: CreateAccountValues
): Promise<EfeResponse<RecoveryTokenResponse>> {
    try {
        return await EfeApi.Users.post<RecoveryTokenResponse>('/api/v1/users/singup', values).then(
            (response: AxiosResponse<RecoveryTokenResponse>) => {
                return Promise.resolve({
                    data: response.data,
                    status: 'Success',
                    success: true,
                    code: response.status,
                    message: 'Ok',
                });
            }
        );
    } catch (error) {
        return Promise.reject(error);
    }
}

export default {
    getToken,
    refreshToken,
    logout,
    createAccount,
};
